import React from 'react';
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select } from '@material-ui/core';
import { colors } from '@/styles';

// Compact multi-select filter. `options` = [{ value, label }]; empty selection = no filter (All).
const FilterSelect = ({ label, options, value, onChange }) => (
    <FormControl variant="outlined" size="small" style={{ minWidth: 170 }}>
        <InputLabel>{label}</InputLabel>
        <Select
            multiple
            value={value}
            label={label}
            onChange={(e) => onChange(e.target.value)}
            renderValue={(selected) => {
                if (!selected.length) return 'All';
                return options
                    .filter((opt) => selected.includes(opt.value))
                    .map((opt) => opt.label)
                    .join(', ');
            }}
            MenuProps={{ getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } }}
        >
            {options.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                    <Checkbox
                        size="small"
                        checked={value.includes(opt.value)}
                        style={{ color: value.includes(opt.value) ? colors.greens.primary : undefined }}
                    />
                    <ListItemText primary={opt.label} />
                </MenuItem>
            ))}
        </Select>
    </FormControl>
);

export default FilterSelect;
